import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0,
    token: null,
    user: null
  },
  getters: {
    registered: state => {
      return state.user && state.user.registered
    }
  },
  mutations: {
    increment: state => state.count++,
    decrement: state => state.count--,
    login: (state, token) => {
      state.token = token
      localStorage.setItem('token', token)
      window.axios.defaults.headers.common['Authorization'] = 'Token ' + token

      window.axios.get('/users/current/').then(response => {
        state.user = response.data

        // if currently accessing the homepage > get the last modified list and display it
        if (state.route.path === '/') {
          window.axios.get('/lists/latest').then(response => {
            router.push({
              name: 'edit-list',
              params: { token: response.data.token }
            })
          }).catch(response => console.log(response))
        }
      })
    },
    logout: state => {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
      delete window.axios.defaults.headers.common['Authorization']
    }
  },
  actions: {
  }
})
